module.exports = __webpack_public_path__ + "linkedin.3899e87c741f93a85706.svg";


//////////////////
// WEBPACK FOOTER
// /revet-web/src/assets/images/linkedin.svg
// module id = ../../../../../src/assets/images/linkedin.svg
// module chunks = styles